var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoNumbers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 54,
    rx: 27,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1713 15.2144L44.184 15.2298C44.6463 15.7949 44.8504 16.5039 44.8164 17.2622L43.5237 34.0263L43.5236 34.0284C43.4222 35.5058 42.2284 36.6425 40.8518 36.6425H40.6514L40.4506 36.6068L40.443 36.6054L40.4353 36.6045C40.22 36.5799 40.0797 36.412 40.1006 36.2169L40.1007 36.2159C40.1271 35.9603 40.2965 35.8377 40.447 35.8531L40.6624 35.8873L40.6713 35.8887L40.6802 35.8895C41.7556 35.9816 42.7546 35.0845 42.8377 33.9436C42.8377 33.9435 42.8377 33.9434 42.8377 33.9433L44.1321 17.216L44.1322 17.2145C44.1727 16.645 44.0063 16.1176 43.6745 15.6807C43.338 15.2377 42.8689 14.966 42.3132 14.9201C42.313 14.9201 42.3128 14.9201 42.3127 14.9201L19.6418 12.9704L19.6418 12.9704L19.6401 12.9702C19.0886 12.9266 18.581 13.1065 18.1646 13.458L18.159 13.4628L18.1536 13.4679C17.7437 13.8578 17.4911 14.3417 17.4482 14.9165L17.2636 17.1352C17.2363 17.3915 17.0647 17.5133 16.9137 17.4953L16.9125 17.4952C16.6972 17.4705 16.557 17.3026 16.5779 17.1076L16.5779 17.1076L16.5784 17.1017L16.7632 14.8809C16.7632 14.8806 16.7633 14.8803 16.7633 14.8801C16.8315 14.1244 17.1729 13.4404 17.7194 12.9372C18.2623 12.4374 18.9685 12.1916 19.6706 12.2618L19.674 12.2621L42.3423 14.2116C42.3429 14.2116 42.3435 14.2117 42.344 14.2117C43.0493 14.2828 43.6935 14.6375 44.1713 15.2144Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8519 19.3223H35.6349C37.0751 19.3223 38.3061 20.6006 38.3061 22.1523V38.9204C38.3061 40.4727 37.1092 41.7505 35.6349 41.7505H12.8519C11.411 41.7505 10.1807 40.508 10.1807 38.9204V22.1523C10.1807 20.6 11.3775 19.3223 12.8519 19.3223Z",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoNumbers);
export default __webpack_public_path__ + "static/media/photoNumbers.50666db983ec0a9ba45f553ea155167f.svg";
export { ForwardRef as ReactComponent };